import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import SuccessAlert from './../child/Alert/SuccessAlert';
import DengerAlert from './../child/Alert/DengerAlert';




const ForgotPasswordLayer = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  const navigate = useNavigate();

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    const token = localStorage.getItem("authToken");
    if (token) {
      navigate("/dashboard"); // Redirect if already logged in
    }
    document.body.classList.add("signin-page");
    return () => {
      document.body.classList.remove("signin-page"); // Cleanup when leaving the page
    };
  }, [navigate]);


  const validateInputs = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleForgotPass = async (e) => {
    e.preventDefault(); // Prevent form reload
    if (!validateInputs()) return;
    setLoading(true);
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/forgotPassword`;
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!response.ok) {
        throw new Error("Incorrect email. Please check your credentials and try again.");
      }
      const data = await response.json();
      localStorage.setItem("email",email);
       const now = Date.now();
        localStorage.setItem("otpStartTime", now.toString()); // ✅ Reset the timer
      setSuccessMessage("An OTP has been successfully sent to your email address");
      setTimeout(() => {
        setSuccessMessage("");
       
        navigate("/otpVerify");
      }, 3000);
      //navigate("/dashboard"); // Redirect to dashboard after login
    } catch (error) {
      setErrorMessage(error.message);
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  return (

    <section className="auth bg-base d-flex flex-wrap">
       {successMessage && <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />}
       {errorMessage && <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />}
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src={`${process.env.REACT_APP_PUBLIC_UR}assets/images/auth/forgotPass.png`}  alt="Auth" />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            {/* <Link to="/" className="mb-40 max-w-290-px"> */}
               <img src={`${process.env.REACT_APP_PUBLIC_UR}/assets/images/logo.png`} alt="Logo" /> 
            {/* </Link> */}
            <h4 className="mb-12">Forgot Password</h4>
            <p className="mb-32 text-secondary-light text-lg">
            Enter the email address associated with your account and we will send you a One Time Code to reset your password.
            </p>
          </div>

          <form onSubmit={handleForgotPass}>
            {/* Email Field */}
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Enter Email"
                autoComplete="email"
                maxLength="64"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrors((prev) => ({ ...prev, email: "" }));
                }}
              />
              
            </div>
            {errors.email && <p className="text-danger mt-1">{errors.email}</p>}
            {/* Submit Button */}
            <button
              type="submit"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={loading}
            >
              {loading ? "Submit..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ForgotPasswordLayer;
